// eslint-disable-next-line import/no-extraneous-dependencies
import _ from 'lodash';
const HEATMAP_MAX_NEGATIVE_COLOR = '#19ac19';
const HEATMAP_MIN_NEGATIVE_COLOR = '#b3e3b3';
const HEATMAP_FILL_COLOR_NONE = '#f2f2f2';
const HEATMAP_MIN_POSITIVE_COLOR = '#fcdbdb';
const HEATMAP_MAX_POSITIVE_COLOR = '#f48686';
// All colors must be on a gradient--defining a very small increment
// so the gradient between any color and gray is rarely encountered
const HEATMAP_GRADIENT_INCREMENT = 0.0001;
const HEATMAP_POSITIVE_COLOR_CUTOFF = 0.45 + HEATMAP_GRADIENT_INCREMENT;
const HEATMAP_NEGATIVE_COLOR_CUTOFF = 0.55 - HEATMAP_GRADIENT_INCREMENT;
export const MIN_SQUARE_SIZE = 15;
export const NO_DATA_HEIGHT = 325;
export const FULL_WIDTH = '100%';
export const HIGHCHARTS_HEATMAP_DEFAULT_OPTIONS = {
    chart: {
        type: 'heatmap',
        spacing: [0, 0, 0, 0],
        plotBackgroundColor: 'transparent',
        backgroundColor: 'transparent',
    },
    plotOptions: {
        series: {
            states: {
                hover: {
                    enabled: false,
                },
            },
        },
    },
    title: {
        text: '',
    },
    credits: {
        enabled: false,
    },
    legend: {
        enabled: false,
    },
    colorAxis: {
        stops: [
            [0, HEATMAP_MAX_NEGATIVE_COLOR],
            [0.45, HEATMAP_MIN_NEGATIVE_COLOR],
            [HEATMAP_POSITIVE_COLOR_CUTOFF, HEATMAP_FILL_COLOR_NONE],
            [HEATMAP_NEGATIVE_COLOR_CUTOFF, HEATMAP_FILL_COLOR_NONE],
            [0.55, HEATMAP_MIN_POSITIVE_COLOR],
            [1, HEATMAP_MAX_POSITIVE_COLOR],
        ],
        min: -1,
        max: 1,
    },
    exporting: {
        enabled: false,
    },
    xAxis: {
        categories: [],
        title: {
            text: '',
        },
        labels: {
            rotation: 270,
            useHTML: true,
            format: '<span style="font-size: 13px;" class="text-default">{text}</span>',
        },
        opposite: true,
        lineColor: 'transparent',
    },
    yAxis: {
        categories: [],
        title: {
            text: '',
        },
        reversed: true,
        gridLineWidth: 0,
        labels: {
            useHTML: true,
            format: '<span style="font-size: 13px;" class="text-default">{text}</span>',
        },
    },
    series: [
        {
            type: 'heatmap',
            name: 'data',
            data: [],
            lineWidth: 0,
            rowsize: 1,
            colsize: 1,
            borderWidth: 5,
            nullColor: '#FFF',
            borderColor: '#FFF',
            turboThreshold: 0, // TODO: set the limit of points. ie 2000
        },
    ],
};
export const HIGHCHARTS_HEATMAP_DEFAULT_PRESENTATION_OPTIONS = _.merge({}, HIGHCHARTS_HEATMAP_DEFAULT_OPTIONS, {
    chart: {
        animation: false,
        events: {
            render: () => {
                // @ts-ignore
                window.ycharts.chartLoadedResolver();
            },
        },
    },
    plotOptions: {
        series: {
            animation: false,
        },
        heatmap: {
            dataLabels: {
                animation: { defer: 0 },
            },
        },
    },
    xAxis: {
        labels: {
            distance: 0,
            format: '<span style="font-size: 12px;" class="text-default">{text}</span>',
        },
    },
    yAxis: {
        labels: {
            distance: 0,
            format: '<span style="font-size: 12px;" class="text-default">{text}</span>',
        },
    },
});
export const PORTFOLIO_OPTIMIZER_DATA_KEYS = [
    'baselinePortfolioId',
    'securityIds',
    'startDate',
    'endDate',
    'frequency',
    'riskMetric',
    'optimizerId',
    'strategy',
    'targetValue',
    'weightBounds',
    'optimizedWeightings',
    'optimizeByBroadAssetClass',
    'broadAssetClassWeightBounds',
];
